var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.graph.nodes),function(node){return _c('node-vuex',{key:node.identifier,attrs:{"node":node}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }